import Button from 'components/Button';
import { Dropdown } from 'components/Dropdown';
import { CodeEMeasurements, NoteCheck, Ticket } from 'components/Icons';
import BarCode from 'components/Icons/BarCode';
import ChevronRight from 'components/Icons/ChevronRight';
import CreditCard from 'components/Icons/CreditCard';
import { InvoiceStatus } from 'components/InvoiceStatus';
import { MessageTypePayment } from 'components/InvoiceT/components/MessageTypePayment';
import { capitalizeFirstLetter, formattedValue } from 'helpers/util';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { api } from 'services/api';
import styled, { css } from 'styled-components';
import DetailsService from './Components/DetailsService/DetailsService';
import DownloadFiscal from './Components/DownloadFiscal/DownloadFiscal';
import loadingIcon from 'assets/image/loading.svg';
import Toast from 'components/Toast/Toast';

// Estilos para o componente da tabela
const TableWrapper = styled.div`
  width: 100%;
  min-width: 277px;
  border-radius: 1rem;
  background-color: white;
`;

const Table = styled.table`
  width: 100% !important;
  border-collapse: collapse;
  background-color: white;
  border-radius: 1rem;

  table-layout: auto; // Alterado para auto, permitindo que o navegador ajuste as larguras das colunas

  // A coluna "Serviço" ocupa 50% da largura da tabela
  .service-cell {
    width: 40%;
  }

  // As outras colunas ocupam um total de 50% (dividido igualmente entre elas)
  .value-cell,
  .dueDate-cell,
  .status-cell {
    width: 12%; // As colunas "Valor", "Vence em", "Status" e "Ações" ocupam 12.5% cada
  }
  .actions-cell {
    width: 26%; // As colunas "Valor", "Vence em", "Status" e "Ações" ocupam 12.5% cada
  }

  // Media Query para telas entre 720px e 1023px
  @media (max-width: 1023px) and (min-width: 801px) {
    .value-cell,
    .dueDate-cell {
      display: none; // Esconde as colunas "Valor" e "Status"
    }

    .service-cell {
      width: 50%; // Aumenta a largura da coluna "Serviço" para ocupar o espaço das outras duas
    }

    // Esconde os cabeçalhos "Valor" e "Status"
    th.value-header,
    th.dueDate-header {
      display: none;
    }

    .actions-cell {
      width: 30%;
    }
    // Ajusta o cabeçalho "Serviço" e "Vence em"
    th.service-header {
      width: 50%;
    }
  }
  @media (max-width: 800px) and (min-width: 720px) {
    .value-cell,
    .dueDate-cell {
      display: none; // Esconde as colunas "Valor" e "Status"
    }

    .service-cell {
      width: 50%; // Aumenta a largura da coluna "Serviço" para ocupar o espaço das outras duas
    }

    // Esconde os cabeçalhos "Valor" e "Status"
    th.value-header,
    th.dueDate-header {
      display: none;
    }

    .actions-cell {
      width: 10%;
    }
    // Ajusta o cabeçalho "Serviço" e "Vence em"
    th.service-header {
      width: 50%;
    }
  }

  // Media Query para telas menores que 720px
  @media (max-width: 720px) {
    .value-cell,
    .dueDate-cell {
      display: none; // Esconde as colunas "Valor", "Status", e "Vence em"
    }

    .service-cell {
      width: 100%; // A coluna "Serviço" ocupa toda a largura
    }

    .actions-cell {
      width: 100%; // A coluna "Ações" ocupa toda a largura também
    }

    // Esconde todos os cabeçalhos das colunas "Valor", "Status", e "Vence em"
    th.value-header,
    th.dueDate-header {
      display: none;
    }

    th.service-header {
      width: 100%;
    }

    th.actions-header {
      width: 100%;
    }
  }
`;

const Wrapperbutton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const WrapperbuttonDropDown = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 24px;
`;
const SpanButton = styled.span<{ isDisable?: boolean }>`
  ${({ isDisable }) => css`
    font-size: 16px;
    color: ${isDisable ? 'rgba(184, 184, 184, 1)' : 'black'};
  `}
`;
const TableHeader = styled.thead`
  background-color: white;
`;
const TitleHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 24px 24px 0px 24px;
  align-items: center;
  flex-wrap: wrap;
  .title-table {
    color: black;
    font-size: 20px !important;
    font-weight: 600;
  }
  .button-header {
    color: #298ee6;
    font-size: 16px;
    font-weight: 700;

    cursor: pointer;
  }
`;
const TableHeaderCell = styled.th`
  padding: 24px;
  padding-bottom: 8px;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  border-radius: 10px;
  border-bottom: 1px solid rgba(216, 216, 216, 1);
`;

const TableRow = styled.tr`
  border-bottom: 1px solid rgba(242, 242, 242, 1);
  &.loading-row {
    height: 100%;
    td {
      padding: 0; // Remover o padding da célula para manter o centramento
    }
  }
`;
export const LoaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
`;
export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title-table {
    color: black;
    font-size: 20px !important;
    font-weight: 600;
  }
  .button-header {
    color: #298ee6;
    font-size: 16px;
    font-weight: 700;

    cursor: pointer;
  }
`;
export const ContentFilter = styled.div`
  display: flex;
  padding: 4px;
  border-radius: 80px;
  border: 1px solid rgba(216, 216, 216, 1);
`;

export const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  > span {
    color: #298ee6;
    padding: 24px;
    cursor: pointer;
  }
`;
export const ButtonStyled = styled.button<{
  selected: boolean;
}>`
  background-color: ${({ selected }) => (selected ? '#298ee6' : 'transparent')};
  color: ${({ selected }) => (selected ? '#ffffff' : '#808080')};
  border: ${({ selected }) =>
    selected ? '1px solid rgba(216, 216, 216, 1)' : 'none'};
  padding: 4px 16px;
  border-radius: 80px;
  cursor: pointer;
  font-size: 16px;
  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${({ selected }) =>
      selected ? '#298ee6' : 'rgba(0, 0, 0, 0.1)'};
  }
`;
const TableCell = styled.td`
  padding: 16px 24px;

  border-bottom: 1px solid rgba(242, 242, 242, 1);
  font-size: 16px;
`;
export const ContentEmpty = styled.div`
  width: 100%;
  display: flex;
  background-color: white;
  padding: 64px 24px;
  justify-content: center;
  gap: 16px;
  flex-wrap: wrap;
  border-radius: 12px;
`;
type ResponsiveTableProps = {
  value: any;
  loadingTable: boolean;
  disableButtonMore?: boolean;
  moreValues?: () => void;
  showButtonMore?: boolean;
  showHeader?: boolean;
  filter?: string;
  setFilter?: (el: string) => void;
  linkHeader?: () => void;
};
type ToastEntity = {
  message: string;
  type: 'success' | 'error' | 'warning';
};
const ResponsiveTable = ({
  value,
  loadingTable,
  disableButtonMore,
  moreValues,
  showButtonMore,
  filter,
  setFilter,
  linkHeader,
  showHeader,
}: ResponsiveTableProps) => {
  const [isMobile, setIsMobile] = useState(false);
  const accessToken = localStorage.getItem('accessToken');
  const idToken = localStorage.getItem('idToken');
  const [onOpenDetailsService, setOnOpenDetailsService] = useState(false);
  const [showStatementDetails, setShowStatementDetails] = useState(false);
  const [toast, setToast] = useState(false);
  const [dataForToast, setDataForToast] = useState<ToastEntity | undefined>(
    undefined,
  );
  const handleCloseToast = () => {
    setToast(false);
  };
  const [valueForModal, setValueForModal] = useState<any>();
  const fetchDataBillings = async (idBilling: any) => {
    try {
      const response = await api.get(
        `client/billings/${idBilling}/linkboleto`,
        {
          headers: {
            'content-Type': 'application/json',
            Authorization: `Bearer ${accessToken}`,
            idToken,
          },
        },
      );
      // setStatusError(response.status);
      return response.data.data.link2via;
    } catch (error: any) {
      setDataForToast({
        type: 'error',
        message:
          'Tivemos um problema para abrir o boleto. Contate o suporte se o erro persistir.',
      });
      setToast(true);
      //   if (error.response) {
      //     setStatusError(error.response.status);
      //   }
      // } finally {
      //   setIsLoading(false);
    }
  };
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Verificar no carregamento
    checkMobile();

    // Adicionar event listener para mudanças de largura
    window.addEventListener('resize', checkMobile);

    // Limpar event listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  const onClickHandlerBoleto = async (idBilling: any) => {
    const link = await fetchDataBillings(idBilling);
    if (!link) {
      // setStatusError(400);
      return;
    }
    window.open(`${link}`, '_blank');
  };
  const ListBillings = (
    invoiceStatusText: any,
    invoicesBillings: any,
    idTypePay: any,
    creditCardNumber: any,
    description: any,
    idBilling: any,
    invoiceDate: any,
    issuanceDate: any,
    paymentDate: any,
  ) => {
    if (idTypePay === 1) {
      //tratativas sobre Boleto
      if (invoiceStatusText === 'Paga') {
        if (invoicesBillings.length === 0) {
          return (
            <Wrapperbutton>
              <MessageTypePayment
                icon={<NoteCheck color="#B8B8B8" />}
                text="Notas Fiscais"
                content="A nota fiscal dessa fatura ficará disponível em breve."
                colorText="#B8B8B8"
                position="left"
              />
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setValueForModal({
                    invoiceDate,
                    paymentDate,
                    issuanceDate,
                    idBilling,
                    title: description,
                  });

                  setOnOpenDetailsService(true);
                }}
              >
                <ChevronRight />
              </span>
            </Wrapperbutton>
          );
        } else {
          return (
            <Wrapperbutton>
              <Button
                onClick={() => {
                  setValueForModal({
                    description,
                    invoicesBillings,
                  });
                  setShowStatementDetails(true);
                }}
                icon={<NoteCheck />}
              >
                Notas Fiscais
              </Button>

              <span
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setValueForModal({
                    invoiceDate,
                    paymentDate,
                    idBilling,
                    issuanceDate,
                    title: description,
                  });
                  setOnOpenDetailsService(true);
                }}
              >
                <ChevronRight />
              </span>
            </Wrapperbutton>
          );
        }
      } else if (
        invoiceStatusText === 'Aberta' ||
        invoiceStatusText === 'Vencida'
      ) {
        return (
          <Wrapperbutton>
            <Button
              icon={<Ticket />}
              onClick={() => onClickHandlerBoleto(idBilling)}
            >
              Ver boleto
            </Button>
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setValueForModal({
                  invoiceDate,
                  paymentDate,
                  issuanceDate,
                  idBilling,
                  title: description,
                });
                setOnOpenDetailsService(true);
              }}
            >
              <ChevronRight />
            </span>
          </Wrapperbutton>
        );
      }
      return (
        <Wrapperbutton>
          <MessageTypePayment
            icon={<BarCode />}
            text="Boleto bancário"
            content={`Cobrança indisponível para download`}
            position="left"
          />
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setValueForModal({
                invoiceDate,
                paymentDate,
                idBilling,
                issuanceDate,
                title: description,
              });
              setOnOpenDetailsService(true);
            }}
          >
            <ChevronRight />
          </span>
        </Wrapperbutton>
      );
    } else if (idTypePay === 4) {
      //Tratativas sobre Cartão de Crédito
      if (invoiceStatusText === 'Paga') {
        if (invoicesBillings.length === 0) {
          let lastNumbersCreditCard = ' de Crédito';
          if (creditCardNumber.length > 0) {
            lastNumbersCreditCard = ` final ${creditCardNumber.substring(
              creditCardNumber.length - 4,
              creditCardNumber.length,
            )}`;
          }
          return (
            <Wrapperbutton>
              <MessageTypePayment
                icon={<CreditCard />}
                text={`Cartão ${lastNumbersCreditCard}`}
                content="A nota fiscal dessa fatura ficará disponível em breve."
                position="left"
              />
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setValueForModal({
                    invoiceDate,
                    paymentDate,
                    issuanceDate,
                    idBilling,
                    title: description,
                  });
                  setOnOpenDetailsService(true);
                }}
              >
                <ChevronRight />
              </span>
            </Wrapperbutton>
          );
        } else {
          return (
            <Wrapperbutton>
              <Button
                onClick={() => {
                  setValueForModal({
                    description,
                    invoicesBillings,
                  });
                  setShowStatementDetails(true);
                }}
                icon={<NoteCheck />}
              >
                Notas Fiscais
              </Button>
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  setValueForModal({
                    invoiceDate,
                    paymentDate,
                    issuanceDate,
                    idBilling,
                    title: description,
                  });
                  setOnOpenDetailsService(true);
                }}
              >
                <ChevronRight />
              </span>
            </Wrapperbutton>
          );
        }
      } else if (
        invoiceStatusText === 'Aberta' ||
        invoiceStatusText === 'Vencida'
      ) {
        return (
          <Wrapperbutton>
            <MessageTypePayment
              icon={<CreditCard />}
              text="Cartão de crédito"
              content="A cobrança será debitada no Cartão de Crédito cadastrado."
              position="left"
            />
            <span
              style={{ cursor: 'pointer' }}
              onClick={() => {
                setValueForModal({
                  invoiceDate,
                  paymentDate,
                  issuanceDate,
                  idBilling,
                  title: description,
                });
                setOnOpenDetailsService(true);
              }}
            >
              <ChevronRight />
            </span>
          </Wrapperbutton>
        );
      }
      return (
        <Wrapperbutton>
          <MessageTypePayment
            icon={<CreditCard />}
            text="Cartão de crédito"
            content="Cobrança Indisponível."
            position="left"
          />
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setValueForModal({
                invoiceDate,
                paymentDate,
                issuanceDate,
                idBilling,
                title: description,
              });
              setOnOpenDetailsService(true);
            }}
          >
            <ChevronRight />
          </span>
        </Wrapperbutton>
      );
    }
    return <span style={{ width: '100px' }}></span>;
  };
  const ButtonForDropDown = (
    title: any,
    icon: any,
    isDisable: boolean,
    onClick: any,
  ) => {
    return (
      <WrapperbuttonDropDown onClick={onClick}>
        <SpanButton isDisable={isDisable}>{title}</SpanButton>
        {icon}
      </WrapperbuttonDropDown>
    );
  };
  const BodyDropDown = (
    invoiceStatusText: any,
    invoicesBillings: any,
    idTypePay: any,
    creditCardNumber: any,
    description: any,
    idBilling: any,
    invoiceDate: any,
    issuanceDate: any,
    paymentDate: any,
  ) => {
    if (idTypePay === 1) {
      //tratativas sobre Boleto
      if (invoiceStatusText === 'Paga') {
        if (invoicesBillings.length === 0) {
          return (
            <>
              {ButtonForDropDown(
                'Notas Fiscais',
                <NoteCheck color="#B8B8B8" />,
                true,
                () => null,
              )}
              {ButtonForDropDown(
                'Detalhes da fatura',
                <ChevronRight />,
                false,
                () => {
                  setValueForModal({
                    invoiceDate,
                    paymentDate,
                    idBilling,
                    issuanceDate,
                    title: description,
                  });
                  setOnOpenDetailsService(true);
                },
              )}
            </>
          );
        } else {
          return (
            <>
              {ButtonForDropDown(
                'Notas Fiscais',
                <NoteCheck color="black" />,
                false,
                () => {
                  setValueForModal({
                    description,
                    invoicesBillings,
                  });
                  setShowStatementDetails(true);
                },
              )}
              {ButtonForDropDown(
                'Detalhes da fatura',
                <ChevronRight />,
                false,
                () => {
                  setValueForModal({
                    invoiceDate,
                    paymentDate,
                    issuanceDate,
                    idBilling,
                    title: description,
                  });
                  setOnOpenDetailsService(true);
                },
              )}
            </>
          );
        }
      } else if (
        invoiceStatusText === 'Aberta' ||
        invoiceStatusText === 'Vencida'
      ) {
        return (
          <>
            {ButtonForDropDown(
              'Ver boleto',
              <Ticket color="black" />,
              false,
              () => onClickHandlerBoleto(idBilling),
            )}
            {ButtonForDropDown(
              'Detalhes da fatura',
              <ChevronRight />,
              false,
              () => {
                setValueForModal({
                  invoiceDate,
                  paymentDate,
                  issuanceDate,
                  idBilling,
                  title: description,
                });
                setOnOpenDetailsService(true);
              },
            )}
          </>
        );
      }
      return (
        <>
          {ButtonForDropDown('Boleto bancário', <BarCode />, true, () => null)}
          {ButtonForDropDown(
            'Detalhes da fatura',
            <ChevronRight />,
            false,
            () => {
              setValueForModal({
                invoiceDate,
                paymentDate,
                idBilling,
                issuanceDate,
                title: description,
              });
              setOnOpenDetailsService(true);
            },
          )}
        </>
      );
    } else if (idTypePay === 4) {
      //Tratativas sobre Cartão de Crédito
      if (invoiceStatusText === 'Paga') {
        if (invoicesBillings.length === 0) {
          let lastNumbersCreditCard = ' de Crédito';
          if (creditCardNumber.length > 0) {
            lastNumbersCreditCard = ` final ${creditCardNumber.substring(
              creditCardNumber.length - 4,
              creditCardNumber.length,
            )}`;
          }
          return (
            <>
              {ButtonForDropDown(
                `Cartão ${lastNumbersCreditCard}`,
                <CreditCard />,
                true,
                () => null,
              )}
              {ButtonForDropDown(
                'Detalhes da fatura',
                <ChevronRight />,
                false,
                () => {
                  setValueForModal({
                    invoiceDate,
                    issuanceDate,
                    paymentDate,
                    idBilling,
                    title: description,
                  });
                  setOnOpenDetailsService(true);
                },
              )}
            </>
          );
        } else {
          return (
            <>
              {ButtonForDropDown(
                'Notas Fiscais',
                <NoteCheck color="black" />,
                false,
                () => {
                  setValueForModal({
                    description,
                    invoicesBillings,
                  });
                  setShowStatementDetails(true);
                },
              )}
              {ButtonForDropDown(
                'Detalhes da fatura',
                <ChevronRight />,
                false,
                () => {
                  setValueForModal({
                    invoiceDate,
                    paymentDate,
                    issuanceDate,
                    idBilling,
                    title: description,
                  });
                  setOnOpenDetailsService(true);
                },
              )}
            </>
          );
        }
      } else if (
        invoiceStatusText === 'Aberta' ||
        invoiceStatusText === 'Vencida'
      ) {
        return (
          <>
            {ButtonForDropDown(
              `Cartão de crédito`,
              <CreditCard />,
              false,
              () => null,
            )}
            {ButtonForDropDown(
              'Detalhes da fatura',
              <ChevronRight />,
              false,
              () => {
                setValueForModal({
                  invoiceDate,
                  paymentDate,
                  idBilling,
                  title: description,
                  issuanceDate,
                });
                setOnOpenDetailsService(true);
              },
            )}
          </>
        );
      }
      return (
        <>
          {ButtonForDropDown(
            `Cartão de crédito`,
            <CreditCard />,
            true,
            () => null,
          )}
          {ButtonForDropDown(
            'Detalhes da fatura',
            <ChevronRight />,
            false,
            () => {
              setValueForModal({
                invoiceDate,
                paymentDate,
                issuanceDate,
                idBilling,
                title: description,
              });
              setOnOpenDetailsService(true);
            },
          )}
        </>
      );
    }
    return <span style={{ width: '100px' }}></span>;
  };
  const Loader = () => {
    return (
      <LoaderContent>
        <img src={loadingIcon} width={36} height={36} />
      </LoaderContent>
    );
  };

  return (
    <>
      <TableWrapper>
        {showHeader && (
          <TitleHeader>
            <span className="title-table">Histórico de faturas</span>
            {filter && setFilter ? (
              <ContentFilter>
                <ButtonStyled
                  selected={filter === 'vencida'}
                  onClick={() => setFilter('vencida')}
                >
                  Boletos
                </ButtonStyled>
                <ButtonStyled
                  selected={filter === 'paga'}
                  onClick={() => setFilter('paga')}
                >
                  Notas fiscais
                </ButtonStyled>
              </ContentFilter>
            ) : (
              <span className="button-header" onClick={linkHeader}>
                {!isMobile ? 'Ver histórico completo' : 'Histórico'}
              </span>
            )}
          </TitleHeader>
        )}
        {filter && filter === 'vencida' && value.length < 1 && !loadingTable ? (
          <ContentEmpty>
            <CodeEMeasurements />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
              }}
            >
              <span style={{ fontSize: '24px', fontWeight: 'bold' }}>
                Nenhum boleto em aberto
              </span>
              <span style={{ fontSize: '16px', maxWidth: '350px' }}>
                As faturas da imobiliária já foram pagas.
              </span>
            </div>
          </ContentEmpty>
        ) : (
          <Table>
            <TableHeader>
              <tr>
                <TableHeaderCell className="service-header">
                  Serviço
                </TableHeaderCell>
                <TableHeaderCell className="value-header">
                  Valor
                </TableHeaderCell>
                <TableHeaderCell className="dueDate-header">
                  Vence em
                </TableHeaderCell>
                <TableHeaderCell className="status-header">
                  Status
                </TableHeaderCell>
                <TableHeaderCell className="actions-header"></TableHeaderCell>
              </tr>
            </TableHeader>

            <tbody>
              {loadingTable ? (
                <TableRow className="loading-row">
                  <TableCell colSpan={5}>
                    <LoaderContent>
                      <Loader />
                    </LoaderContent>
                  </TableCell>
                </TableRow>
              ) : (
                <>
                  {value?.map((item: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell className="service-cell">
                        {item.description}
                      </TableCell>
                      <TableCell className="value-cell">
                        {formattedValue(item.paidValue)}
                      </TableCell>
                      <TableCell className="dueDate-cell">
                        {moment(item.dueDate).format('L')}
                      </TableCell>
                      <TableCell className="status-cell">
                        <InvoiceStatus
                          text={`${capitalizeFirstLetter(item.status)}`}
                          status={item.status}
                        />
                      </TableCell>
                      <TableCell className="actions-cell">
                        {!isMobile ? (
                          ListBillings(
                            `${capitalizeFirstLetter(item.status)}`,
                            item.invoices_billings,
                            item.id_typePay,
                            item.creditCardNumber,
                            item.description,
                            item.id_billing,
                            moment(item.dueDate).format('L'),
                            moment(item.issuanceDate).format('L'),
                            moment(item.paymentDate).format('L'),
                          )
                        ) : (
                          <Dropdown
                            title={false}
                            width="24rem"
                            element={<span>...</span>}
                            height="4.5rem"
                            position="-.3"
                          >
                            {BodyDropDown(
                              `${capitalizeFirstLetter(item.status)}`,
                              item.invoices_billings,
                              item.id_typePay,
                              item.creditCardNumber,
                              item.description,
                              item.id_billing,
                              moment(item.dueDate).format('L'),
                              moment(item.issuanceDate).format('L'),
                              moment(item.paymentDate).format('L'),
                            )}
                          </Dropdown>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              )}
            </tbody>
          </Table>
        )}
        {showButtonMore && !disableButtonMore && (
          <TitleHeader>
            <ButtonContent style={{ width: '100%' }}>
              <span onClick={moreValues} className="button-header">
                Ver mais
              </span>
            </ButtonContent>
          </TitleHeader>
        )}
        {filter && (
          <TitleHeader>
            <ButtonContent style={{ width: '100%' }}>
              <span
                className="button-header"
                onClick={linkHeader}
                style={{ paddingTop: '0' }}
              >
                Todas as faturas
              </span>
            </ButtonContent>
          </TitleHeader>
        )}
      </TableWrapper>
      {onOpenDetailsService && (
        <DetailsService
          closeDrawer={() => setOnOpenDetailsService(false)}
          idBilling={valueForModal.idBilling}
          title={valueForModal.title}
          invoiceDate={valueForModal.invoiceDate}
          issuanceDate={valueForModal.issuanceDate}
          paymentDate={valueForModal.paymentDate}
        />
      )}
      {showStatementDetails && (
        <DownloadFiscal
          closeDrawer={() => setShowStatementDetails(false)}
          product={valueForModal?.description}
          invoices={valueForModal?.invoicesBillings}
        />
      )}
      {toast && (
        <Toast
          type={dataForToast?.type || 'warning'}
          message={dataForToast?.message || ''}
          onClose={handleCloseToast}
        />
      )}
    </>
  );
};

export default ResponsiveTable;
